import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import TopBar from './components/TopBar';
import AppProvider from './hooks';
import Routes from './routes';
import { ContextPanelProvider } from './components/BasicStepper/HolderSteps/ContextPanel';
import CacheBuster from 'react-cache-buster';
import version from '../package.json';
const App: React.FC = () => (

      <CacheBuster
        currentVersion={version.version}
        isEnabled={false} 
        isVerboseMode={false} 
        reloadOnDowngrade={false}
        metaFileDirectory={'/onboarding'} 
      >
      <Router basename={'/onboarding'} >
        <AppProvider>
          <TopBar />
              <ContextPanelProvider>
                <Routes />
              </ContextPanelProvider>
        </AppProvider>
      </Router>
    </CacheBuster>
) 
  

export default App;
